(function () {
  const SELECTOR = '[data-preptera-key-features-slider]';

  function getGap(track) {
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0');
    return Number.isFinite(gap) ? gap : 0;
  }

  function getStep(track) {
    const slide = track.querySelector('.preptera-key-features__slide');
    if (!slide) return track.clientWidth;
    return slide.getBoundingClientRect().width + getGap(track);
  }

  function updateControls(root) {
    const track = root.querySelector('[data-preptera-key-features-track]');
    const prev = root.querySelector('[data-preptera-key-features-prev]');
    const next = root.querySelector('[data-preptera-key-features-next]');
    const dots = root.querySelectorAll('[data-preptera-key-features-dot]');
    if (!track) return;

    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    const atStart = track.scrollLeft <= 2;
    const atEnd = track.scrollLeft >= maxScroll - 2;

    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;

    if (!dots.length) return;

    const step = getStep(track);
    const index = step > 0 ? Math.round(track.scrollLeft / step) : 0;
    const clamped = Math.max(0, Math.min(dots.length - 1, index));

    dots.forEach((dot, i) => {
      const active = i === clamped;
      dot.classList.toggle('is-active', active);
      if (active) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  function scrollBySlides(track, direction) {
    track.scrollBy({
      left: getStep(track) * direction,
      behavior: 'smooth',
    });
  }

  function scrollToIndex(track, index) {
    track.scrollTo({
      left: getStep(track) * index,
      behavior: 'smooth',
    });
  }

  function initSlider(root) {
    if (root.dataset.prepteraKeyFeaturesReady === 'true') return;

    const track = root.querySelector('[data-preptera-key-features-track]');
    const prev = root.querySelector('[data-preptera-key-features-prev]');
    const next = root.querySelector('[data-preptera-key-features-next]');
    const dots = root.querySelectorAll('[data-preptera-key-features-dot]');

    if (!track) return;

    root.dataset.prepteraKeyFeaturesReady = 'true';

    prev?.addEventListener('click', () => scrollBySlides(track, -1));
    next?.addEventListener('click', () => scrollBySlides(track, 1));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.index || 0);
        scrollToIndex(track, index);
      });
    });

    let ticking = false;
    track.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          updateControls(root);
          ticking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener(
      'resize',
      () => {
        updateControls(root);
      },
      { passive: true }
    );

    updateControls(root);
  }

  function scan(scope = document) {
    scope.querySelectorAll?.(SELECTOR).forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', (event) => {
    scan(event.target);
  });
})();
